import { SelectProps } from "@amzn/awsui-components-react-v3/polaris/select";

export function convertMultiSelectOptionsToPolaris3Schema(data: Array<SelectProps.Option>) : SelectProps.Options{
      return data.map(d => { return {
        label: d.label,
        // id is replaced with value in V3
        value: d.value,
        description: d.description}
      })
}